import React from 'react';

import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Modal as MUIModal } from '@material-ui/core';

import Colours from '../../styles/colours';

const useStyles = makeStyles((theme) => ({
  paper: {
    position:        'absolute',
    minWidth:        400,
    width:           'fit-content',
    backgroundColor: Colours.White,
    borderRadius:    '8px',
    top:             '50%',
    left:            '50%',
    transform:       'translate(-50%, -50%)',
    boxShadow:       theme.shadows[5],
    padding:         theme.spacing(2, 4, 3),
  },
}));

function Modal({ open, onClose, children }) {
  const classes = useStyles();

  return (
    <MUIModal
      open={open}
      onClose={onClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    >
      <div className={classes.paper}>
        {children}
      </div>
    </MUIModal>
  );
}

Modal.propTypes = {
  open:     PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  onClose:  PropTypes.func.isRequired,
};

export default Modal;
